import Vue from "vue"
import VueRouter from "vue-router"
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)
//这里的路由不需要在侧边栏根据权限显示的路由放这里,根据权限返回的路由使用router.addRoutes动态加载
const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/Login")
  },
  {
    path: "/person/index",
    name: "personalManage",
    component: () => import("@/views/User/PersonalCenter")
  }
]

const router = new VueRouter({
  routes
})

export default router
